<template>
  <div class="slider" :style="styleObject">
    <a-button type="primary" @click="handlePlayClick"> {{ playText }}</a-button>
    <a-dropdown>
      <template #overlay>
        <a-menu @click="handleMenuClick">
          <a-menu-item key="100">快速 <CheckOutlined :style="style100"/></a-menu-item>
          <a-menu-item key="200">中速 <CheckOutlined :style="style200"/></a-menu-item>
          <a-menu-item key="300">慢速 <CheckOutlined :style="style300"/></a-menu-item>
        </a-menu>
      </template>
      <a-button type="primary"> 速度 <CaretDownOutlined /> </a-button>
    </a-dropdown>

    <a-slider 
      :marks="marks" 
      :step="step"
      :max="max"
      :min="min"
      v-model:value="value"
      :tip-formatter="formatter" 
      @change="handleChange"/>
    <span class="message">{{ message }}</span>
  </div>
</template>

<script>
import { CaretDownOutlined, CheckOutlined } from '@ant-design/icons-vue';

export default {
  components: {
    CaretDownOutlined,
    CheckOutlined
  },
  props: ["min", "max", "step", "marks", "list", "display"],
  data() {
    return {
      playText: "播放",
      speed: 100,
      status: "stop",
      value: 0
    }
  },
  computed: {
    style100() {
      return this.speed != 100 ? { "display": "none" } : {}
    },
    style200() {
      return this.speed != 200 ? { "display": "none" } : {}
    },
    style300() {
      return this.speed != 300 ? { "display": "none" } : {}
    },
    message() {
      const value = this.value
      if (this.list && this.list[value]) {
        return this.list[value].display
      }
      return ''
    },
    styleObject() {
      return this.display == "none" ? {"display": "none"} : {}
    }
  },
  methods: {
    play() {
        if (this.$data.value <= this.max - 1) {
          this.$data.value = this.$data.value + 1
          this.$emit("playStep", this.$data.value)
          this.timer = setTimeout(() => { this.play() }, this.$data.speed)
        } else {
          setTimeout(() => {
            this.$data.value = this.min
            this.$data.status = "stop"
            this.$data.playText = "播放"
            this.$emit("playStopped")
          }, this.$data.speed)
        }
    },

    formatter(value) {
      if (this.list && this.list[value]) {
        console.log(this.list[value].display)
        return this.list[value].display
      }
      return null
    },

    handlePlayClick() {
      clearTimeout(this.timer)

      if(this.$data.status == "stop") {
        this.$data.status = "playing"
        this.$data.playText = "暂停"
        this.$emit("playStart")
        this.play()
      } else {
        setTimeout(() => {
          this.$data.status = "stop"
          this.$data.playText = "播放"
          this.$emit("playStopped")
        }, this.$data.speed)
      }
    },

    handleMenuClick(e) {
      console.log('click', e);
      this.$data.speed = parseFloat(e.key)
    },

    handleChange(value) {
      console.log('change: ', value);
      this.$emit("sliderStep", value)
    }
  },
};

</script>

<style>
.slider { padding: .5rem .5rem; opacity: 0.9}
.slider .ant-btn {margin-right: .2rem;}
.slider .ant-btn span {font-size: 12px;}
.slider .ant-slider {width: 300px; display: inline-block; margin-left:20px;}
.slider .ant-slider-with-marks {margin-bottom: 4px; margin-top: -10px;}
.slider .ant-slider-mark span {font-size: 10px;}

.slider .ant-slider-mark span:first-child { margin-left: 0px; }
.slider .ant-slider-mark span:last-child { margin-left: 0px; }
.slider span.message {margin-left: 30px; font-size: 10px; display: inline-block; white-space: nowrap}

.slider .ant-slider-handle {background-color: #2190ff;  border-color: #2190ff}

@media (max-width: 780px) {
  .slider { padding: .1rem .1rem; margin: 5px 10px;}
  .slider .ant-slider {width: 150px; }
  .slider span.message {margin:8px 0px 4px 0px; text-align:center; display: block}
}

</style>